<img [src]="src" [attr.width]="width" [attr.height]="width" alt="" aria-hidden="true">
